// extracted by mini-css-extract-plugin
export default {"summary-container":"MedicineWiseStockTransferReportSummary_summary-container__KkNv9","summary-ctas":"MedicineWiseStockTransferReportSummary_summary-ctas__qbXuT"};